import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  PurchaseOrderInitialStateType,
  SetPurchaseOrderConstantsPayloadActionType,
} from 'features/PurchaseOrder/@types/PurchaseOrder'
import {
  cancelPurchaseOrder,
  fetchPurchaseOrderFilterLocations,
  fetchPurchaseOrderList,
  fetchVendors,
  SLICE_NAME_PURCHASE_ORDER,
  updatePurchaseOrderStatus,
} from './thunk'

const initialState: PurchaseOrderInitialStateType = {
  isLoading: true,
  constants: {
    locations: [],
    vendors: [],
  },
  pagination: {
    prevCursor: '',
    nextCursor: '',
  },
  purchaseOrders: [],
}

const slice = createSlice({
  name: SLICE_NAME_PURCHASE_ORDER,
  initialState,
  reducers: {
    resetStatePurchaseOrder: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setConstants: (
      state,
      { payload }: PayloadAction<SetPurchaseOrderConstantsPayloadActionType>,
    ) => {
      const { field, value } = payload
      state.constants[field] = value
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<PurchaseOrderInitialStateType>) => {
      builder.addCase(fetchPurchaseOrderFilterLocations.fulfilled, (state, action) => {
        state.constants.locations = action.payload.map((location) => ({
          id: location.location_id,
          name: location.location_name,
        }))
      })
      builder.addCase(fetchVendors.fulfilled, (state, action) => {
        state.constants.vendors = action.payload.data.map((vendor) => ({
          id: vendor.id,
          name: vendor.company_name,
        }))
      })
      builder.addCase(fetchPurchaseOrderList.fulfilled, (state, { payload }) => {
        state.purchaseOrders = payload.data
        state.pagination = {
          prevCursor: payload.pagination.prev_cursor,
          nextCursor: payload.pagination.next_cursor,
        }
      })
    },
    [fetchPurchaseOrderList, updatePurchaseOrderStatus, cancelPurchaseOrder],
  ),
})

export const { resetStatePurchaseOrder, setIsLoading, setConstants } = slice.actions

export default slice.reducer
